import { useEffect, useState } from "react";
import type { User } from "oidc-client-ts";
import { completeLogin } from "../auth/oidc";

type AuthCallbackProps = {
  onSignedIn: (user: User) => void;
};

export function AuthCallback({ onSignedIn }: AuthCallbackProps) {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    completeLogin()
      .then((user) => {
        onSignedIn(user);
        window.location.replace("/chat");
      })
      .catch((caught: unknown) => {
        const message =
          caught instanceof Error ? caught.message : "The identity provider rejected the callback.";
        setError(message);
      });
  }, [onSignedIn]);

  return (
    <main className="centered-screen">
      <section className="status-panel" aria-live="polite">
        {error ? null : <div className="spinner" aria-hidden="true" />}
        <p className="eyebrow">OIDC callback</p>
        <h1>{error ? "Sign-in could not be completed" : "Completing secure sign-in"}</h1>
        <p className={error ? "error" : "muted"}>
          {error ?? "Verifying the authorization response and tenant-scoped token."}
        </p>
        {error ? (
          <button type="button" onClick={() => window.location.replace("/login")}>
            Return to sign in
          </button>
        ) : null}
      </section>
    </main>
  );
}
